import React, { useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import {
  addNewProduct,
  getGroupEntryByGuid,
  getUnitguid,
  addNewProductimg,
} from "../../../services/MasterApiServices";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "../../../style/css/product-master.css";
import { X } from "feather-icons-react/build/IconComponents";
import { pmHue, pmInitials } from "./Product/pmUi";
import AddProductProfile from "./Product/AddProductProfile";
import AddProductSection from "./Product/AddProductSection";
import AddOtherDescription from "./Product/AddOtherDescription";
import toast from "react-hot-toast";
import { ComboProductDetail } from "../../../core/json/ComboProductDetail";
 
import {fetchProduct} from "../../../redux/userSetting";
import { ProductPos } from "../../../core/json/ProductPos";
import { productImagesList } from "../../../core/json/ProductImageList";
import { objectOf } from "prop-types";
 
 
 
const AddProduct = ({ handleClose}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [productImages, setProductImages] = useState([]);
const [thumbnailImage, setThumbnailImage] = useState("");
  console.log(thumbnailImage,"thumbnailImageeeeeee");
  console.log(productImages,"productImageeeeeeeeeeee");

  const dispatch = useDispatch();
  const {
    // sectionList=[],
    taxList=[],
    categoryList = [],
    deliveyTypes = [],
    productList = [],
    unitList = [],
    groupList = [],
    productimageList = [],
  } = useSelector((state) => state.usersetting);
 
  // const section = sectionList?.map((e, i) => ({
  //   IsActive: false,
  //   Section: e?.guid,
  //   Price: "",
  //   Tax: null,
  //   IsTaxIncludedInPrice: false,
  // }));
  const {
    register,
   
    formState: { errors, isValid, isDirty },
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    
    control,
    trigger
  } = useForm({
    mode: "onChange",
    reValidateMode: "onSubmit",
    defaultValues: {
      items: [{ name: "", maxItems: "", comments: "" }],
      //sectionWiseProductDetailList: section,
      name: "",
      shortName: "",
      code: "",
      barCode: "",
      category: "",
      type: "",
      group: "",
      unit: "",
      cost: "",
      basePrice: "",
      otherDiscription: "",
      arabicDescription: "",
      hsnCode: "",
      isRateVaryProduct: false,
      isDailyStockItem: false,
      isMenuItem: false,
    },
  });
 
  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);
 
 
  // Handle form submission for adding or editing a category
 
  const comboType = deliveyTypes?.find((type) => type.name === "Combo"); // Find Combo type
  const COMBO_TYPE_ID = comboType?.guid;
 
  console.log(productimageList,"imaageeeeee");
  
  const handleFormSubmit = async (formData) => {
   console.log(formData,"fooooooooooorm");
   
    // const objsection = new SectionClass();
    // const objcombodetail = new ComboProductDetail();
    // const sectionWiseProductDetailList = getValues()
    //   ?.sectionWiseProductDetailList
    //   ? getValues()?.sectionWiseProductDetailList?.map((e) => ({
    //     Section:
    //       sectionList?.find((item) => item.guid == e.Section) || objsection,
    //     IsActive: e.IsActive,
    //     IsTaxIncludedInPrice: e.IsTaxIncludedInPrice,
    //     Price: Number(e.Price),
    //     tax: taxList?.find((item) => item.guid == e.Tax),
    //   }))
    //   : getValues()?.sectionWiseProductDetail;
 
   
 
    // const ComboProductarray =
    //   watch().type === COMBO_TYPE_ID
    //     ? formData?.items?.map((e, i) => ({
    //       sideChoiceNumber: i,
    //       products: productList?.filter((item) =>
    //         e?.name?.some((pro) => item.guid === pro.value)
    //       ),
    //       quantity: Number(e.maxItems),
    //     }))
    //     : null;
    // const FixedItem = ComboProductarray?.[0] || null;
    // const SideChoices = ComboProductarray?.slice(1) || [];
    // objcombodetail.FixedItem = FixedItem;
    // objcombodetail.SideChoices = SideChoices;

  // Find the tax percentage based on tax ID
  // const selectedTax = taxList.find((tax) => tax.guid === formData.tax);
  // const taxPercentage = selectedTax ? selectedTax.percentage : 0;

  // console.log("Selected Tax ID:", formData.tax);
  // console.log("Calculated Tax Percentage:", taxPercentage);

  // let RetailRate = parseFloat(formData.RetailRate) || 0;

  // // Reverse Calculation if Sales Tax is Included in Price
  // if (formData.isSalesTaxIncludedInPrice) {
  //   RetailRate = RetailRate / (1 + taxPercentage / 100);
  //   console.log("Adjusted Retail Price (Pre-Tax):", RetailRate);
  // }
  const selectedTax = taxList.find((tax) => tax.guid === formData.tax);
  const taxPercentage = selectedTax ? selectedTax.percentage : 0;
  
  let adjustedRetailRate = parseFloat(formData.RetailRate) || 0;

  // Reverse Calculation if Sales Tax is Included in Price
  if (formData.isSalesTaxIncludedInPrice) {
    adjustedRetailRate = adjustedRetailRate / (1 + taxPercentage / 100);

    console.log("Adjusted Retail Priceeee (Pre-Tax):", adjustedRetailRate);
  }

  console.log(formData,"formdataaaaaaaa");
  const objproduct = new ProductPos();
    
   

    
    
  
     objproduct.productImagesList=productImages;
    objproduct.ProdCode = formData.ProdCode;
    objproduct.Description1 = formData.Description1;
    objproduct.ShortDescription =formData.ShortDescription;
    objproduct.ShortName= formData.ShortName;
   
    objproduct.StockTypeID = formData.StockTypeID;
    objproduct.RetailRate = formData.RetailRate;
    objproduct.WSRate= formData.WSRate;
    objproduct.AvgCost= formData.AvgCost;
    objproduct.MinPrice= formData.MinPrice;
    objproduct.ManufactureID=formData.brand
    objproduct.MinQty= formData.MinQty;
    objproduct.ReorderLevel= formData.ReorderLevel;
    objproduct.MaxQty= formData.MaxQty;
    objproduct.TaxPercentage= formData.TaxPercentage;
    objproduct.IsMenuItem= formData.IsMenuItem;
    objproduct.CreatedBy = formData.CreatedBy;
    objproduct.TaxID = formData.tax;
    objproduct.Ubc=formData.Ubc;
    objproduct.Sbc=formData.Sbc;
    objproduct.IsSalesTaxIncludedInPrice = formData.isSalesTaxIncludedInPrice;
    objproduct.IsPurchaseTaxIncludedInPrice=formData.IsPurchaseTaxIncludedInPrice;
    objproduct.RetailRate = adjustedRetailRate; // Send pre-tax value to DB
    objproduct.image = "";
    

    objproduct.ModifiedDate= formData.ModifiedDate;
     objproduct.ReorderQty= formData.ReorderQty;
    // objproduct.CategoryID = categoryList?.find(
    //   (item) => item.guid == formData.category
    objproduct.CategoryID =  formData.category
 
    objproduct.ItemTypeID = formData.type
    objproduct.SubGroupID = formData.group;
    objproduct.UnitID = formData.unit;
    // objproduct.cost = parseFloat(formData.cost);
    // objproduct.basePrice = parseFloat(formData.basePrice);
    // objproduct.otherDescription = formData.otherDescription;
    objproduct.isActive = formData.isActive;
    //objproduct.sectionWiseProductDetailList = sectionWiseProductDetailList;
    // objproduct.sectionWiseProductDetailList =null
   
    // objproduct.comboProductDetail =
    //   watch().type === COMBO_TYPE_ID ? objcombodetail : null;
    // objproduct.arabicDescription = formData.arabicDescription;
    // objproduct.isRateVaryProduct = formData.isRateVaryProduct;
    // objproduct.isDailyStockItem = formData.isDailyStockItem;
    // objproduct.hsnCode = formData.hsnCode;
   
    objproduct.updatedUser = `{${userId?.id}}`;
    objproduct.createdUser = `{${userId?.id}}`;
    objproduct.Branch = branch;
    
    const formDataToSend = new FormData();

    // 1. Append product data as string
    formDataToSend.append("product", JSON.stringify(objproduct));
    console.log(formDataToSend,"formdatatosenddddddd");

    // 2. Append files
    console.log(thumbnailImage,"thumbnailDATATOSEND");
    if (thumbnailImage) {
      formDataToSend.append("thumbimg", thumbnailImage);
    }
    
    if (Array.isArray(productImages)) {
      productImages.forEach((file) => {
        formDataToSend.append("productImage", file);
      });
    } else if (productImages) {
      formDataToSend.append("productImage", productImages);
    }
    


console.log(objproduct,"objproducttttttttttt");


    try {
      const response = await addNewProductimg(formDataToSend);
    
      if (response === true) {
        handleClose();
        dispatch(fetchProduct(branch));
        toast.success("Success");
      } else {
        toast.error("Upload failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Upload failed");
      console.error("Error handling:", error);
    }
    
    // Logging for debug
    for (let pair of formDataToSend.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }
  };    

 // console.log("Final Retail Ratee sent to DB:", objproduct.RetailRate);

  //   try {
  //     const response = await addNewProduct(objproduct);
  //     if (response == true) {
  //       handleClose();
  //       dispatch(fetchProduct(branch));
  //       toast.success("Success");
  //     } else if (response == false) {
  //       toast.error("false");
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.Message);
  //     console.error("Error handling :", error);
  //   }
   //};
  function resetmodal() {
    reset();
  }


  console.log(thumbnailImage,"ADDTHUMNAILIMG");
  
  console.log(productImages,"ADDIMAGEeeeeee");
 
  return (
    <section className="pm-detail">
            <div className="pm-dhead">
              <span
                className="pm-thumb"
                style={{ "--h": pmHue(watch("category")) }}
              >
                {pmInitials(watch("Description1"))}
              </span>
              <div className="pm-dtitle">
                <div className="pm-t">
                  {watch("Description1") || "Add Product"}
                </div>
                <div className="pm-s">{watch("ProdCode") || "no code yet"}</div>
              </div>
              <span className="pm-pill new">New</span>
              <button
                type="button"
                className="pm-close"
                onClick={handleClose}
                aria-label="Close"
              >
                <X />
              </button>
            </div>
            <form className="pm-form" onSubmit={handleSubmit(handleFormSubmit)}>
              {/* <Tabs
                selectedIndex={tabIndex}
                onSelect={async (index) => {
                  const isValid = await trigger(); // Validate current tab fields
                  if (isValid) {
                    setTabIndex(index); // Switch tabs if validation passes
                  } else {
                    const firstErrorField = document.querySelector(".error");
                    console.log(firstErrorField, "firstErrorFielddddddd");

                    if (firstErrorField) {
                      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
                      firstErrorField.focus();
                    }
                    // alert("Please fix the errors in this tab before switching.");
                    toast.error("Please fill the required fields to continue.");
                  }
                }}
              > */}
              <Tabs
                className="pm-tabs"
                selectedIndex={tabIndex}
                onSelect={(index) => {
                  setTabIndex(index);
                }}
              >
                <TabList>
                  <Tab>Profile</Tab>
                  {/* <Tab>Section Price</Tab> */}
                  <Tab>Other Details</Tab>
                </TabList>

                <TabPanel>
                  <AddProductProfile
                    register={register}
                    productName={watch("Description1")}
                    watch={watch}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                  />
                </TabPanel>
                {/* <TabPanel>
                  <AddProductSection
                    register={register}
                    getValues={getValues}
                    watch={watch}
                    setValue={setValue}
                    errors={errors}
                  />
                </TabPanel> */}
                <TabPanel>
                  <AddOtherDescription
                    productImages={productImages}
                    setProductImages={setProductImages}
                    thumbnailImage={thumbnailImage}
                    setThumbnailImage={setThumbnailImage}
                    errors={errors}
                    //productName={watch("Description1")}
                    watch={watch}
                    register={register}
                    setValue={setValue}
                  />
                </TabPanel>
              </Tabs>

              <div className="pm-dfoot">
                <span
                  className={
                    "pm-msg" + (Object.keys(errors || {}).length ? " err" : "")
                  }
                >
                  {Object.keys(errors || {}).length
                    ? "Some required fields are missing — check both tabs"
                    : "Fields marked * are required"}
                </span>
                <span className="pm-sp" />
                <button
                  type="button"
                  className="pm-btn pm-btn-ghost"
                  onClick={() => {
                    resetmodal();
                    setTabIndex(0); // Reset to the first tab
                  }}
                >
                  Reset
                </button>
                <button
                  type="submit"
                  className="pm-btn pm-btn-primary"
                  // disabled={!!Object.keys(errors || {}).length}
                >
                  Save
                </button>
              </div>
            </form>
    </section>
  );
};
 
export default AddProduct;
 